// extracted by mini-css-extract-plugin
export default {"container":"ListPattern_container__3L8Bc"};